<!-- Slim Banner: Tactical variant, Only used in Header currently  -->
<script setup lang="ts">
import { personalizationControl } from '#imports'
import { ActionFields } from '~/components/cms/Action/actionHelpers'
import { Document } from '@contentful/rich-text-types'

type Fields = {
  fields: {
    content: Document
    personalizationTags: PersonalizationTags
    disclaimer: ActionFields
    supportingData?: {
      home: {
        variant: {
          children: {
            backgroundColour?: string
            textColour?: string
          }
        }
      }
    }
    link: ActionFields
  }
}

type MoustacheProps = {
  data?: Fields[]
}

const props = defineProps<MoustacheProps>()
const moustacheEl = ref<HTMLElement>()

const entry = computed(() => {
  const moustacheList = props.data?.filter((entry) => personalizationControl(entry?.fields?.personalizationTags))
  return moustacheList?.[0] // Show only the first Banner
})

onMounted(() => {
  if (moustacheEl.value) {
    // allow 2px leway to avoid showing white background
    // TODO: look into potential solution to not use javascript to get moustache behaviour right
    document.documentElement.style.setProperty('--moustache-height', `${moustacheEl.value.clientHeight - 2}px`)
  } else {
    // set as -1px to ensure plp filters do not show 1px gap when no moustache present
    document.documentElement.style.setProperty('--moustache-height', '-1px')
  }
})
</script>
<template>
  <section
    ref="moustacheEl"
    class="moustache"
    v-if="entry?.fields"
    :style="{
      background: entry?.fields?.supportingData?.home?.variant?.children?.backgroundColour,
      color: entry?.fields?.supportingData?.home?.variant?.children?.textColour,
    }"
  >
    <div class="container">
      <div class="moustache__wrap">
        <div class="moustache__rtp">
          <RichText :document="entry?.fields?.content" />
          <Action
            class="moustache__tnc"
            v-if="entry?.fields?.disclaimer?.fields"
            v-bind="entry?.fields?.disclaimer?.fields"
          />
        </div>
        <Action v-if="entry?.fields?.link" v-bind="entry?.fields?.link" />
      </div>
    </div>
  </section>
</template>

<style lang="postcss">
.moustache {
  position: static;
  margin-top: var(--height);
  min-height: 1.6rem;
  z-index: 9;
  background: var(--surface-accent); /* Default background */
  padding-bottom: var(--space-20);
  padding-top: var(--space-20);

  > .container {
    position: relative;
  }

  .moustache__wrap {
    width: 100%;
    height: 100%;
    padding-block: var(--space-20);
    display: flex;
    gap: var(--space-50);
    align-items: center;
    justify-content: space-between;
  }

  .moustache__rtp {
    max-width: 100%;
  }

  .rich-text {
    display: inline;
    width: min-content;

    p {
      margin: 0;
    }
    .link {
      font-size: var(--text-small); /* 12px link 14px text to match PROD! */
      padding-right: 0.25rem; /* match to PROD */
    }
  }

  .moustache__tnc {
    font-size: var(--text-disclaimer);
    display: inline-flex;
    align-items: flex-end;
    text-decoration: none; /* match to PROD */
  }

  @media (--tablet) {
    .moustache__wrap {
      justify-content: center;
      padding-right: 3.5rem; /* space for absolute T&C link */
    }

    .moustache__tnc {
      position: absolute;
      top: 50%;
      right: 1rem; /* match to PROD */
      translate: 0 -40%; /* match to PROD */
    }
  }

  @media (--desktop) {
    .moustache__wrap {
      padding-right: 0;
    }
  }
}
</style>
